$(function() {
  //Equal height cols
  $.fn.extend({
    equalHeights: function() {
      var top = 0;
      var row = [];
      var classname = ("equalHeights" + Math.random()).replace(".", "");
      $(this)
        .each(function() {
          var thistop = $(this).offset().top;
          if (thistop > top) {
            $("." + classname).removeClass(classname);
            top = thistop;
          }
          $(this).addClass(classname);
          $(this).height("auto");
          var h = Math.max.apply(
            null,
            $("." + classname)
              .map(function() {
                return $(this).outerHeight();
              })
              .get()
          );
          $("." + classname).height(h);
        })
        .removeClass(classname);
    },
    calcNavHeight: function() {
      var menuItems = $(this).children("li");
      var currentWindowInnerHeight = $(window).height();
      var scale = 80;

      var listPadding = currentWindowInnerHeight / menuItems.length / scale;

      $(menuItems).each(function() {
        $($(this).find("a")[0]).css("padding", listPadding + "em 0em");
      });
    }
  });

  $(window)
    .resize(function() {
      $(".grid-item .grid-info .equal-height").equalHeights();
      $(".two-col .col").equalHeights();
      $(".nav-main > ul").calcNavHeight();
    })
    .trigger("resize");

  setTimeout(function() {
    $(".grid-item .grid-info .equal-height").equalHeights();
    $(".two-col .col").equalHeights();
  }, 800);

  //Equal width buttons
  if ($("section").length) {
    $.fn.extend({
      equalWidths: function() {
        return this.length
          ? this.width(
              Math.max.apply(
                Math,
                this.map(function() {
                  return $(this).width();
                })
              )
            )
          : this;
      }
    });

    // TODO: fix this so it only applies to multiple buttons in one section (if there are multiple buttons).
    if ($(this).find(".btn-equal").length > 1) {
      $(this)
        .find(".btn-equal")
        .equalWidths();
    }
  }

  //Slideout menu
  if ($(window).width() > 1200) {
    $(".nav-main").addClass("open");
    $(".nav-icon").addClass("active");
    $(".nav-icon i")
      .removeClass("fa-bars")
      .addClass("fa-arrow-left");
    // HACK manually change the icon (assumes React class names) - move to a prop in the future
    $(".nav-icon.Icon")
      .removeClass("icon-chevron-left icon-close")
      .addClass("icon-th-list");
    $("body").addClass("menu-open");
  } else {
    $(".nav-main").removeClass("open");
    $(".nav-icon").removeClass("active");
    $(".nav-icon i")
      .removeClass("fa-arrow-left")
      .addClass("fa-bars");
    // HACK manually change the icon (assumes React class names) - move to a prop in the future
    $(".nav-icon.Icon")
      .removeClass("icon-th-list icon-close")
      .addClass("icon-chevron-left");
    $("body").removeClass("menu-open");
  }

  $(".nav-icon").on("click", handleNavigationMenu);

  //Sub menu
  $(".has-submenu > a").on("click", function(e) {
    e.preventDefault();
    if (
      $(this)
        .parent("li")
        .hasClass("active")
    ) {
      $(this)
        .parent("li")
        .removeClass("active");
      if ($(window).width() <= 767) {
        $(this)
          .next("ul")
          .slideUp("fast");
      }
    } else {
      $(this)
        .parent("li")
        .addClass("active");
      if ($(window).width() > 767) {
        $(".nav-main > ul > li")
          .not(".active")
          .slideUp("fast");
        $(".nav-main > ul > li.active > a").slideUp("fast");
        $(".nav-main > ul > li.has-submenu.active ul").append(
          '<li class="close-sub"><a href="#"><i class="fa fa-arrow-up"></i></a></li>'
        );
        setTimeout(function() {
          $(".has-submenu.active > ul").slideDown("fast");
        }, 300);
      } else {
        $(this)
          .next("ul")
          .slideDown("fast");
      }
    }
  });

  $("body").on("click", ".close-sub a", function(e) {
    e.preventDefault();
    $(".has-submenu.active > ul").slideUp("fast");
    $(".has-submenu").removeClass("active");
    setTimeout(function() {
      $(".nav-main > ul > li, .nav-main > ul > li > a").slideDown("fast");
      $(".close-sub").remove();
    }, 300);
  });

  //Sticky sub nav
  if ($(".sticky-nav").length) {
    $(function() {
      // Check the initial Position of the fixed_nav_container
      var stickyItemTop = $(".sticky-nav").offset().top,
        stickyItem = $(".sticky-nav nav");
      containerHeight = $(".sticky-nav nav").height();
      containerPos = containerHeight * -1;

      if ($(".full-height:first-child").length) {
        if ($(window).width() > 767) {
          var topMargin = 135;
        } else {
          var topMargin = 110;
        }
      } else {
        var topMargin = 53;
      }

      $(window)
        .scroll(function() {
          if ($(document).scrollTop() > stickyItemTop - topMargin) {
            stickyItem.addClass("stuck");
          } else {
            stickyItem.removeClass("stuck");
          }
        })
        .trigger("scroll");
    });
  }

  //Highlight active tab in sub nav
  if ($(".nav-sub").length) {
    // Cache selectors
    var lastId,
      topMenu = $(".nav-sub"),
      topMenuHeight = topMenu.outerHeight() + 47,
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function() {
        var item = $($(this).attr("href"));
        if (item.length) {
          return item;
        }
      });

    // Bind to scroll
    $(window).on("load scroll", function() {
      // Get container scroll position
      var fromTop = $(this).scrollTop() + topMenuHeight;
      // Get id of current scroll item
      var cur = scrollItems.map(function() {
        if ($(this).offset().top < fromTop) return this;
      });
      // Get the id of the current element
      cur = cur[cur.length - 1];
      var id = cur && cur.length ? cur[0].id : "";

      if (lastId !== id && topMenu.hasClass("stuck")) {
        lastId = id;
        // Set/remove active class
        var activeItem = menuItems
          .parent()
          .removeClass("active")
          .end()
          .filter("[href='#" + id + "']")
          .parent()
          .addClass("active");
        centreActive(activeItem);
      }
    });

    //Centre active sticky nav item
    $(".nav-sub a").on("click", function() {
      centreActive($(this).parent());
    });

    function centreActive(activeItem) {
      if ($(window).width() <= 767) {
        var myScrollPos =
          activeItem.offset().left +
          activeItem.outerWidth(true) / 2 +
          $(".nav-sub ul").scrollLeft() -
          $(".nav-sub ul").width() / 2;
        $(".nav-sub ul").animate({ scrollLeft: myScrollPos });
      }
    }
  }

  //Sticky key
  if ($(".sticky-key").length) {
    if ($(window).width() > 767) {
      $(function() {
        // Check the initial Position of the fixed_nav_container
        var stickyItemTop = $(".sticky-key").offset().top,
          stickyItem = $(".sticky-key .inner"),
          stickyItemHeight = $(".sticky-key").height();

        $(window).on("load scroll", function() {
          if (
            $(document).scrollTop() >
            stickyItemTop - 100 + stickyItemHeight
          ) {
            stickyItem.addClass("stuck");
          } else {
            stickyItem.removeClass("stuck");
          }
        });
      });
    }
  }

  //Scroll to next
  $(".next-section").click(function() {
    if ($(".nav-sub").hasClass("stuck")) {
      if ($(window).width() > 767) {
        var offsetVal = 128;
      } else {
        var offsetVal = 105;
      }
    } else {
      var offsetVal = 49;
    }

    var cls =
      $(this)
        .closest("section")
        .next()
        .offset().top - offsetVal;
    $("html, body").animate({ scrollTop: cls }, "300");
  });

  //Scroll to anchor ID
  $('a[href^="#"]:not([href="#"])').click(function(e) {
    e.preventDefault();
    var target = this.hash;

    if (
      $(".nav-sub").hasClass("stuck") ||
      $(this)
        .first()
        .parents()
        .eq(3)
        .hasClass("nav-sub")
    ) {
      if ($(window).width() > 767) {
        var offsetVal = 123;
      } else {
        var offsetVal = 103;
      }
    } else if (
      $(this)
        .first()
        .parents()
        .eq(2)
        .hasClass("nav-sidebar")
    ) {
      var offsetVal = 101;
    } else {
      var offsetVal = 49;
    }

    $("html, body").animate(
      { scrollTop: $(target).offset().top - offsetVal },
      300
    );
  });

  //Fade In animation
  /*
    $('.fade-in').addClass('hide').viewportChecker({
        classToAdd: 'show animated fadeInUpSmall',
        offset: 100
    });

    $('.bounce-in').addClass('hide').viewportChecker({
        classToAdd: 'show animated bounceIn',
        offset: 100
    });
*/

  // Check if in view
  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();
    return elemTop <= docViewBottom && elemBottom >= docViewTop;
  }

  function isScrolledIntoViewDelayed(elem) {
    var docViewTop = $(window).scrollTop() + $(window).height() / 2;
    var docViewBottom = docViewTop + $(window).height() / 10;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();
    return elemTop <= docViewBottom && elemBottom >= docViewTop;
  }

  $(window)
    .on("scroll", function() {
      // Crawling elements
      $(".crawl").each(function() {
        if (isScrolledIntoView(this) === true) {
          $(this).addClass("in-view");
        } else {
          $(this).removeClass("in-view");
        }

        if ($(".crawl").hasClass("in-view")) {
          var offset = $(this).offset(),
            viewportOffsetTop = offset.top - $(document).scrollTop();
          if ($(window).width() < 768) {
            var parallaxDistance = viewportOffsetTop / -50;
          } else if ($(this).hasClass("crawl2")) {
            var parallaxDistance = viewportOffsetTop / -30;
          } else {
            var parallaxDistance = viewportOffsetTop / -20;
          }
          parallaxCSS = "translate3d(0, " + parallaxDistance + "px , 0)";
          $(this).css("transform", parallaxCSS);
        }
      });
    })
    .trigger("scroll");

  //Flapper
  $(".flapper-container")
    .trigger("classChange")
    .viewportChecker({
      offset: 100
    });

  if ($(".flapper-container").length) {
    var flapperDisplay = $(this).find(".flapper-display"),
      flapperVal = $(this)
        .find(".flapper-val")
        .val();

    flapperDisplay.flapper({
      width: 9,
      chars_preset: "num",
      timing: 500
    });

    // $(window).on('scroll',function(){
    // 	$('.flapper-container').each(function () {
    // 		if ($(this).hasClass('full-visible')){
    // 		    setTimeout(function(){
    // 		        flapperDisplay.val(flapperVal).change();
    // 		        var toggle = false;
    // 		    }, 1000);
    // 		}
    // 	});
    // }).trigger('scroll');
  }

  // Meals donated api for flapper
  var mealsDonatedPromise = null;

  function updateMealsDonated() {
    // Don't do anything if we're waiting on the api
    if (mealsDonatedPromise !== null) {
      return;
    }

    mealsDonatedPromise = jQuery.get(
      "https://zambrero.xchangefusion.com/api/product/getdonationbyid/2",
      function(result) {
        $(".flapper-display")
          .val(JSON.parse(result).TotalItemCount)
          .change();
        mealsDonatedPromise = null;
      }
    );
  }

  updateMealsDonated();
  setInterval(updateMealsDonated, 10000 /* 10s */);

  //Box Grid 2 col
  $(".grid-two-col > .grid-item:nth-child(2n + 2)").after(
    '<div class="break"></div>'
  );

  //Forms
  // if ($('.form').length) {

  $("body").on("focusout", ".form input, .form textarea", function() {
    if ($(this).val() != "") {
      $(this).addClass("has-content");
    } else {
      $(this).removeClass("has-content");
    }
  });

  if ($(".datepicker").length) {
    $(function() {
      $(".datepicker").datepicker({
        dateFormat: "yy-mm-dd"
      });

      if ($(".restaurant-application-form .datepicker").length > 0) {
        $(".restaurant-application-form .datepicker").datepicker(
          "option",
          "minDate",
          0
        );
      }
    });
  }

  $(".form option").each(function() {
    var myStr = $(this).text();
    if ($(window).width() < 480) {
      if (myStr.length > 30) {
        $(this).text(myStr.substring(0, 30) + "...");
      }
    }
  });

  //Selectric
  $(function() {
    $("select").selectric();
  });

  $("body").on("change", ".selectric-hide-select > select", function() {
    var $this = $(this);
    if (!$this.val()) {
      $this
        .parent()
        .parent()
        .parent()
        .find("label")
        .removeClass("has-content");
    } else {
      $this
        .parent()
        .parent()
        .parent()
        .find("label")
        .addClass("has-content");
    }
  });

  //Job application form
  if ($(".days-select").length) {
    // 			var selectedDays = $('input[name=days-select]:checked').val();

    $("input[name=days-select]").on("change", function() {
      dayHours = $(this).attr("data-tab");

      if ($(this).is(":checked")) {
        $("." + dayHours).fadeIn();
      } else {
        $("." + dayHours).hide();
        $("." + dayHours + " select")
          .prop("selectedIndex", 0)
          .selectric("refresh");
        $("." + dayHours + " label").removeClass("has-content");
      }
    });
  }

  $(".inputfile").each(function() {
    var $input = $(this),
      $label = $input.next("label"),
      labelVal = $label.html();

    $input.on("change", function(e) {
      var fileName = "";

      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute("data-multiple-caption") || "").replace(
          "{count}",
          this.files.length
        );
      else if (e.target.value) fileName = e.target.value.split("\\").pop();

      if (fileName) $label.find("span").html(fileName);
      else $label.html(labelVal);
    });

    // Firefox bug fix
    $input
      .on("focus", function() {
        $input.addClass("has-focus");
      })
      .on("blur", function() {
        $input.removeClass("has-focus");
      });
  });
  // }

  //Allergens table
  if ($(".allergens > div > table").length) {
    if ($(window).width() <= 767) {
      $(".allergens table:not(.name)")
        .children("tbody")
        .wrapInner('<div class="tbody">');
      $(".allergens table thead").on("click", function() {
        var $this = $(this);

        if (
          $this
            .next("tbody")
            .children(".tbody")
            .hasClass("show")
        ) {
          $this
            .next("tbody")
            .children(".tbody")
            .removeClass("show");
          $this
            .next("tbody")
            .children(".tbody")
            .slideUp("fast");
          $this.removeClass("active");
        } else {
          $this
            .parent()
            .parent()
            .find("thead")
            .removeClass("active");
          $this
            .parent()
            .parent()
            .find("tbody .tbody")
            .removeClass("show");
          $this
            .parent()
            .parent()
            .find("tbody .tbody")
            .slideUp("fast");
          $this
            .next("tbody")
            .children(".tbody")
            .toggleClass("show");
          $this
            .next("tbody")
            .children(".tbody")
            .slideToggle("fast");
          $this.addClass("active");
        }
      });
    }
  }

  //Hide store phone
  if ($(".store-info .phone").length) {
    hideStorePhone();
  }

  //Accordion
  if ($(".accordion").length) {
    $(".accordion .acc-item h4").on("click", function() {
      var $this = $(this);

      if ($this.next("div").hasClass("show")) {
        $this.next("div").removeClass("show");
        $this.next("div").slideUp("fast");
        $this.parent().removeClass("active");
      } else {
        $this
          .parent()
          .parent()
          .find(".acc-item")
          .removeClass("active");
        $this
          .parent()
          .parent()
          .find(".acc-item > div")
          .removeClass("show");
        $this
          .parent()
          .parent()
          .find(".acc-item > div")
          .slideUp("fast");
        $this.next("div").toggleClass("show");
        $this.next("div").slideToggle("fast");
        $this.parent().addClass("active");
      }
    });
  }

  //FAQ category dropdown
  if ($(".nav-dropdown").length && $(window).width() <= 767) {
    $(".dropdown-label").on("click", function() {
      $(this)
        .toggleClass("active")
        .find(".toggle")
        .toggle();
      $(".nav-dropdown ul").slideToggle("fast");
    });
    //Selectric
    $(function() {
      $("select").selectric();
    });
  }

  //Sticky sidebar
  if ($(".sidebar.sticky").length && $(window).width() > 767) {
    $(function() {
      var $sidebar = $(".sidebar.sticky"),
        $window = $(window),
        offset = $sidebar.offset(),
        topPadding = 106,
        containerHeight = $("article").height();

      $window.scroll(function() {
        if (
          $window.scrollTop() > offset.top - topPadding &&
          $window.scrollTop() < containerHeight + 250
        ) {
          $sidebar.stop().css({
            marginTop: $window.scrollTop() - offset.top + topPadding
          });
        } else {
          $sidebar.stop().css({
            marginTop: 0
          });
        }
      });
    });

    //Highlight active tab in side nav
    // Cache selectors
    var lastId,
      topMenu = $(".nav-sidebar"),
      topMenuHeight = topMenu.outerHeight() + 50,
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function() {
        var item = $($(this).attr("href"));
        if (item.length) {
          return item;
        }
      });

    // Bind to scroll
    $(window).on("load scroll", function() {
      // Get container scroll position
      var fromTop = $(this).scrollTop() + 200;
      // Get id of current scroll item
      var cur = scrollItems.map(function() {
        if ($(this).offset().top < fromTop) return this;
      });
      // Get the id of the current element
      cur = cur[cur.length - 1];
      var id = cur && cur.length ? cur[0].id : "";

      if (lastId !== id) {
        lastId = id;
        // Set/remove active class
        menuItems
          .parent()
          .removeClass("active")
          .end()
          .filter("[href='#" + id + "']")
          .parent()
          .addClass("active");
      }
    });
  }

  /*
   * Modal handling
   */
  var modal = null;

  // Called when the modal's close button is clicked
  function closeModal() {
    // Unlock body scroll
    $("body").css("overflow-y", "auto");

    // Hide modal w/ pretty animation
    modal.animate({ top: modal.height() }, 200, function() {
      modal.hide();
    });
    return false;
  }

  function buildModal(url, title, backTitle) {
    // Lock body scroll
    $("body").css("overflow-y", "hidden");

    // Start the ajax request
    var promise = jQuery.get(url);

    // Build a modal if there isn't one already
    if (!modal) {
      modal = $(
        [
          '<div class="product-modal">',
          '<section class="infobar">',
          '<div class="title"></div>',
          '<div class="back-btn"><a href="#"><i class="ico-close"></i>Back <span></span></a></div>',
          "</section>",
          '<div class="content-wrap"><div class="content-container"></div></div>',
          "</div>"
        ].join("")
      );
      $(".site").append(modal);
      modal.find(".back-btn").click(closeModal);
    }

    // Fill in the details
    modal.find(".title").text(title);
    // if (backTitle) {
    // 	modal.find('.back-btn span').html('to <br/>' + backTitle);
    // }
    var container = modal.find(".content-container");
    container.html("");

    promise.done(function(content) {
      container
        .css("opacity", 0)
        .html(content)
        .animate({ opacity: 1 }, 200);

      modal.find(".crm-form").validate();

      if (url.indexOf("#") !== -1) {
        var anchor = modal.find("#" + url.split("#", 2)[1]);
        var top = anchor.offset().top - container.offset().top;
        container.animate({
          scrollTop: top
        });
      }
    });

    // Pretty transitions!
    modal
      .css("top", modal.height())
      .show()
      .animate({ top: 0 }, 200);
  }

  /* Taking bets on time before they change their mind...
  $('.product-card a').click(function() {
    var $this = $(this);

    buildModal(
      $this.attr('href'),
      $this.closest('.product-card').data('product-title'),
      [$('.modal-title'), $('h1')].filter(result => result.length)[0].first().text()
    );

    return false;
  });
*/

  $(".job-link").click(function() {
    var $this = $(this);

    buildModal(
      $this.attr("href"),
      $this
        .closest(".job-item")
        .find("h3")
        .text(),
      "Jobs"
    );

    return false;
  });

  $(".modal-link").click(function() {
    var $this = $(this);
    buildModal($this.attr("href"), $this.text());
    return false;
  });

  /*
   * Forms
   */
  // Output mapping functions for the JSON objects
  var mappingFuncs = {
    contact: function(formContents) {
      var out = {
        UsrComplaintNatureId: formContents.complaintNature,
        UsrEmailAddress: formContents.email,
        UsrMessage: formContents.message,
        UsrFeedbackTypeId: formContents.feedbackType,
        UsrAllowContact: formContents.allowContact === "yes",
        UsrContactName: formContents.firstName + " " + formContents.lastName,
        UsrContactNumber: formContents.contactNumber,
        UsrContactedForRecentVisit: formContents.aboutVisit == "yes"
      };
      if (formContents.aboutVisit === "yes") {
        out.UsrVisitDateTime =
          formContents.dateVisited + "T" + formContents.timeVisited + ":00.000";
        out.UsrRestaurantId = formContents.store[formContents.storeState] || "";
      }
      return out;
    },

    register: function(formContents) {
      return {
        UsrFirstName: formContents.firstName,
        UsrLastName: formContents.lastName,
        UsrEmailAddress: formContents.email,
        UsrContactNumber: formContents.contactNumber,
        UsrBestContactTime: formContents.bestContactTime,
        UsrInvestmentRange: formContents.investmentRange,
        UsrDiscovery: formContents.howHear,
        UsrDiscoveryOther: formContents.howHearOther,
        UsrFranchiseReason: formContents.franchiseReason,
        UsrFranchiseLocation: formContents.franchiseLocationState,
        UsrPostcode: formContents.franchiseLocationPostcode
      };
    },

    restaurantJobs: function(form) {
      return {
        UsrRestaurantId: form.store[form.storeState] || "",
        UsrPosition: (form.position || []).join(", "),
        UsrWorkType: (form.workType || []).join(", "),
        UsrFirstName: form.firstName,
        UsrLastName: form.lastName,
        UsrEmailAddress: form.email,
        UsrContactNumber: form.phone,
        UsrAge: form.age || "over 21",
        UsrStartDate: form.startDate,
        UsrMondayStart: form.monFrom,
        UsrMondayEnd: form.monTo,
        UsrTuesdayStart: form.tueFrom,
        UsrTuesdayEnd: form.tueTo,
        UsrWednesdayStart: form.wedFrom,
        UsrWednesdayEnd: form.wedTo,
        UsrThursdayStart: form.thuFrom,
        UsrThursdayEnd: form.thuTo,
        UsrFridayStart: form.friFrom,
        UsrFridayEnd: form.friTo,
        UsrSaturdayStart: form.satFrom,
        UsrSaturdayEnd: form.satTo,
        UsrSundayStart: form.sunFrom,
        UsrSundayEnd: form.sunTo,
        UsrWhyZambrero: form.whyZambrero,
        UsrEligibility: form.eligibility
      };
    },

    supportJobs: function(form) {
      return {};
    }
  };

  function submitFormAttachments($this, id, success) {
    var inputs = $this.find("[type=file]");

    if (inputs.length === 0) {
      return success();
    }

    var data = new FormData();
    inputs.each(function(index) {
      var file = this.files[0];
      if (file === undefined) {
        return;
      }
      data.append("files[" + index + "]", file);
    });

    jQuery.ajax({
      type: "POST",
      url: $this.data("endpoint") + "/" + id + "/attachments",
      data: data,
      processData: false,
      contentType: false,
      success: success
    });
  }

  // validation rules
  var dependsAboutVisit = {
    required: {
      depends: function() {
        return $("[name=aboutVisit]").val() === "yes";
      }
    }
  };
  var maxTwoMb = {
    maxsize: 2 * 1024 /*K*/ * 1024 /*M*/,
    accept: "application/pdf"
  };
  var maxSizeMessage = {
    maxsize: function(size) {
      var sizes = ["", "K", "M", "G", "T"];
      var sizePos = 0;
      while (size >= 1024) {
        size /= 1024;
        sizePos++;
      }
      return "File size must not exceed " + size + sizes[sizePos] + "B.";
    },
    accept: function() {
      return "PDF format only";
    }
  };
  var reasonComplaint = "868b28b7-033f-4782-b7cd-105dee87689d";
  var dependsIsComplaint = {
    required: {
      depends: function() {
        return $("[name=feedbackType]").val() === reasonComplaint;
      }
    }
  };

  //Set any specific validation rules in this function
  $(".crm-form").validate({
    errorElement: "label",
    errorPlacement: function(error, element) {
      if (element.is("select")) {
        element = element.closest(".selectric-wrapper");
      }
      error.appendTo(element.parent());
    },
    rules: {
      complaintNature: dependsIsComplaint,
      dateVisited: dependsAboutVisit,
      timeVisited: dependsAboutVisit,
      cover: maxTwoMb,
      cv: maxTwoMb
    },
    messages: {
      cover: maxSizeMessage,
      cv: maxSizeMessage
    }
  });
  // Generic submission handling
  $("body").on("submit", ".crm-form", function() {
    var $this = $(this);

    if (!$this.valid()) {
      return false;
    }

    // get the form as k:v
    var formContents = $this.serializeObject();

    // build the json object we're sending to the crm
    var mapping = $this.data("mapping");
    var output = mappingFuncs[mapping](formContents);

    var submit = $this.find("[type=submit]");
    submit.prop("disabled", true).text("Submitting...");

    jQuery.ajax({
      type: "POST",
      url: $this.data("endpoint"),
      data: JSON.stringify(output),
      contentType: "application/json",
      success: function(response) {
        //Handle errors here and display on page
        // TODO: Set errors properly.
        $(".form-errors").text(response);

        // Attempt to send form attachments then redirect to thanks page
        submitFormAttachments($this, response.id, function() {
          window.location.href = window.location.href + "/thanks";
        });
      },
      error: function(xhr, status, error) {
        $(".form-errors").text(error);
        submit.prop("disabled", false).text("Submit");
      }
    });

    return false;
  });

  //If the restuarant form is on the page add extra validation rules
  if ($(".restaurant-application-form").length > 0) {
    var positionLimit = 2;
    $("input.position").on("change", function(e) {
      if ($(this).siblings(":checked").length >= positionLimit) {
        this.checked = false;
        if ($("#position-error").length == 0) {
          $(this)
            .parent()
            .one()
            .append(
              '<label id="position-error" class="error" for="position">No more than two options can be selected.</label>'
            );
        }
      } else {
        $("#position-error").remove();
      }
    });
    /*
    $(".position").rules( "add", {
        maxlength: 2,
        messages: {
          maxlength: "Please select no more than 2 options"
        }
    });
*/
  }

  // Hide/show form fields based on inputs
  // Contact form
  $(".contact-form [name=feedbackType]").change(function() {
    var complaint = "868b28b7-033f-4782-b7cd-105dee87689d";
    var compliment = "77438ad5-bfd2-4283-ad5b-e39b41b045ee";

    var open = "slideDown";
    var close = "slideUp";

    if ($(this).val() === complaint) {
      $(".contact-form .complaint-nature")[open]();
      $(".contact-form .restaurant-visited")[open]();
      $(".contact-form .about-visit")[open]();
      $(".contact-form .date-visited")[open]();
    } else if ($(this).val() === compliment) {
      func = $(this).val() === compliment ? "slideDown" : "slideUp";
      $(".contact-form .restaurant-visited")[open]();
      $(".contact-form .date-visited")[open]();
      $(".contact-form .about-visit")[open]();

      $(".contact-form .complaint-nature")[close]();
    } else {
      func = "slideUp";
      $(".contact-form .complaint-nature")[close]();
      $(".contact-form .restaurant-visited")[close]();
      $(".contact-form .date-visited")[close]();
      $(".contact-form .about-visit")[close]();
      $(".contact-form [name=aboutVisit][value=no]").prop("checked", true);
    }
  });

  $(".contact-form [name=aboutVisit]").change(function() {
    var func = $(this).val() === "yes" ? "slideDown" : "slideUp";
    $(".contact-form .restaurant-visited")[func]();
    $(".contact-form .date-visited")[func]();
    $(".contact-form .time-visited")[func]();
  });

  // Franchisee form
  $(".register-form [name=howHear]").change(function() {
    var func = $(this).val() === "Other" ? "slideDown" : "slideUp";
    $(".register-form .how-hear-other")[func]();
  });

  // Restaurants job form
  $(".restaurant-application-form [name=storeState]").change(function() {
    var test = $(".restaurant-application-form")
      .find(".store-selector")
      .hide()
      .filter('[data-state="' + $(this).val() + '"]')
      .show();
  });

  // Restaurants job form
  $(".restaurant-application-form [name=over21]").change(function() {
    func = $(this).val() === "no" ? "slideDown" : "slideUp";
    $(".restaurant-application-form .age-select")[func]();
  });

  // Restaurants job form
  $(".contact-form [name=storeState]").change(function() {
    var test = $(".contact-form")
      .find(".store-selector")
      .hide()
      .filter('[data-state="' + $(this).val() + '"]')
      .addClass("select")
      .show();
  });

  // Location results toggle mobile
  if ($(".view-toggle").length && $(window).width() < 992) {
    $(".view-toggle li a").on("click", function(e) {
      e.preventDefault();
      $(".view-toggle li").removeClass("active");
      $(".view-type").fadeOut();
      $(this)
        .parent()
        .addClass("active");

      var selectedView = $(this).attr("class");

      setTimeout(function() {
        $(".view-type." + selectedView).fadeIn();
      }, 500);
    });
  }

  // Funky scrollbar
  $(function() {
    function initScrollPane() {
      if ($(".view-toggle").length && $(window).width() >= 992) {
        $(".scroll-pane").jScrollPane();
      }
    }

    initScrollPane();
    $(window).resize(initScrollPane);
  });

  // Event modal
  if ($(".event-modal").length > 0) {
    $(".event-modal-link").click(function(e) {
      e.preventDefault();
      var eventId = $(this).data("event-id");
      $("#" + eventId).fadeIn("fast");
    });

    $(".event-modal .close").click(function() {
      $(".event-modal").fadeOut("fast");
    });
  }

  if ($(".event-modal form").length > 0) {
    $(".event-modal form").validate();
  }

  if ($(".event-modal form.mailchimp-form").length > 0) {
    $(".event-modal form.mailchimp-form").submit(function(e) {
      // Prevent the form from actually submitting
      e.preventDefault();
      $(".error-summary").remove();
      var thisForm = $(this);

      // Send it to the server
      jQuery.post(
        "/",
        $(this).serializeArray(),
        function(response) {
          if (response.success == true) {
            location.href = window.location.pathname + "/thanks";
          } else if (response.success == false) {
            var failError = response.error;
            $(thisForm).append(
              '<p class="error-summary">Error: ' + failError + "</p>"
            );
          }
        },
        "json"
      );
    });

    $("body").on(
      "click",
      ".event-modal form.mailchimp-form input[type=submit]",
      function() {
        setTimeout(function() {
          if ($("label.error").length) {
            $("label.error").each(function() {
              $(this).appendTo($(this).parent());
            });
          }
        }, 10);
      }
    );
  }

  // Multi-site select
  $(".country-select > .fa").on("click", function() {
    if ($(this).hasClass("fa-caret-down")) {
      $(this)
        .removeClass("fa-caret-down")
        .addClass("fa-caret-up");
    } else {
      $(this)
        .removeClass("fa-caret-up")
        .addClass("fa-caret-down");
    }
    $(this)
      .parent()
      .find("ul li:not(.current)")
      .slideToggle("fast");
  });

  // -----
  // Nutrition Calculator
  // -----

  // Add/remove ingredient
  function toggleIngredient(ingredient) {
    $(ingredient)
      .toggleClass("active")
      .find(".add-indicator")
      .toggleClass("active");

    var values = {};
    $(".nutrition-calculator .ingredient-row.active [data-key]").each(
      function() {
        var $this = $(this);
        var key = $this.data("key");
        if (!values[key]) {
          values[key] = 0;
        }
        values[key] += parseFloat($this.text());
      }
    );

    var $totals = $(".nutrition-calculator .totals");
    $totals.find("[data-key]").text("0");
    for (key in values) {
      $totals.find("[data-key=" + key + "]").text(values[key]);
    }
  }

  function showCalculatorModal(row) {
    var $row = $(row);
    var $modal = $(".calculator-mobile-modal");

    // Remove remnants
    $modal.removeClass("totals active");
    $modal.removeData("ing");

    // copy title over
    $modal.find(".title").html($row.find(".title").html());

    // fill values
    $row.find("[data-key]").each(function() {
      var $this = $(this);
      $modal
        .find("[data-key=" + $this.data("key") + "]")
        .text(parseFloat($this.text()));
    });

    // Show the modal
    $modal.animate({
      top: 0
    });

    $("body").addClass("modal-open");
  }

  $(".nutrition-calculator .add-indicator").click(function() {
    toggleIngredient($(this).closest(".ingredient-row"));
    return false;
  });

  $(".nutrition-calculator .ingredient-row").click(function() {
    // If we're on desktop, just activate the ingredient
    if ($(window).width() >= 768) {
      toggleIngredient(this);
      return;
    }

    // on mobile, show the info modal thing
    var $this = $(this);
    showCalculatorModal($this);
    var $modal = $(".calculator-mobile-modal");
    $modal.data("ing", $this.data("ing"));
    if ($this.hasClass("active")) {
      $modal.addClass("active");
    }
  });

  // Hide the modal when they click the close button
  $(".calculator-mobile-modal .close-icon").click(function() {
    $(".calculator-mobile-modal").animate({
      top: "100%"
    });

    $("body").removeClass("modal-open");
  });

  // Footer total handling
  $(".nutrition-calculator .totals").click(function() {
    // mobile, show the modal
    if ($(window).width() < 768) {
      showCalculatorModal($(this).closest("tfoot"));
      $(".calculator-mobile-modal").addClass("totals");
      return;
    }

    // desktop, show/hide the labels
    var $this = $(this);
    $this.find(".expand-indicator").toggleClass("active");
    $this
      .siblings(".labels")
      .find(".column-label")
      .slideToggle();
  });

  // Modal add/remove button click
  $(".calculator-mobile-modal .btn").click(function() {
    var $modal = $(this).closest(".calculator-mobile-modal");
    toggleIngredient($("[data-ing=" + $modal.data("ing") + "]"));
    $modal.toggleClass("active");
  });

  // Header label scroll lock
  var headerHeight = 89; // header height (49) + float height (40)
  var tbodyOffset = $(".nutrition-calculator tbody").offset();
  if (tbodyOffset) {
    var tbodyTop = tbodyOffset.top;
    $(window).scroll(function() {
      var windowScroll = $(window).scrollTop();
      var visible = tbodyTop < windowScroll + headerHeight;
      $(".calculator-floating-header").toggle(visible);
    });
  }
});

function handleNavigationMenu() {
  // if you can't beat them join them
  // check if slider is defined in the hero, if page does not have will return undefined
  // slider is defined in hero.twig when image slider is selected don't judge me
  if (typeof slider !== "undefined") {
    setTimeout(function() {
      ``;
      slider.update();
    }, 500);
  }

  var resizeAllVideos = function() {
    for (var playerId in players) {
      resizeVideo(playerId);
    }
  };

  if ($(".nav-main").hasClass("open")) {
    $(".nav-icon").removeClass("active");
    setTimeout(function() {
      $(".nav-main").removeClass("open");
      $(".has-submenu.active ul").slideUp("fast");
      $(".has-submenu").removeClass("active");
      resizeAllVideos();
    }, 500);

    if ($(window).width() > 767) {
      $(".nav-icon i")
        .removeClass("fa-arrow-left ico-close")
        .addClass("fa-bars");
      $(".nav-icon.Icon")
        .removeClass("icon-chevron-left icon-close")
        .addClass("icon-th-list");
      $(".nav-main").css({ left: "-200px" });
      $("body")
        .removeClass("menu-open")
        .addClass("menu-close");
      setTimeout(function() {
        $(".nav-main > ul > li, .nav-main > ul > li > a").slideDown("fast");
        $(".close-sub").remove();
        resizeAllVideos();
      }, 500);
    } else {
      $(".nav-icon i")
        .removeClass("ico-close fa-arrow-left")
        .addClass("fa-bars");
      $(".nav-icon.Icon")
        .removeClass("icon-close icon-chevron-left")
        .addClass("icon-th-list");
      $(".nav-main").css({ top: "-120%" });
      setTimeout(function() {
        $(".nav-main").css({ top: "" });
        $("body")
          .removeClass("menu-open")
          .addClass("menu-close");
        resizeAllVideos();
      }, 500);
    }
  } else {
    $(".nav-icon").addClass("active");
    $("body")
      .addClass("menu-open")
      .removeClass("menu-close");
    if ($(window).width() > 767) {
      $(".nav-icon i")
        .removeClass("fa-bars ico-close")
        .addClass("fa-arrow-left");
      $(".nav-icon.Icon")
        .removeClass("icon-th-list icon-close")
        .addClass("icon-chevron-left");
      $(".nav-main").css({ left: "0" });
      setTimeout(function() {
        $(".nav-main").addClass("open");
        resizeAllVideos();
      }, 500);
    } else {
      $(".nav-main").addClass("open");
      $(".nav-icon i")
        .removeClass("fa-bars fa-arrow-left")
        .addClass("ico-close");
      $(".nav-icon.Icon")
        .removeClass("icon-th-list icon-chevron-left")
        .addClass("icon-close");
      resizeAllVideos();
    }
  }
}

function hideStorePhone() {
  $(".store-info .phone").append("<span>Show Number</span>");
  $(".store-info .phone").one("click", false);
  $(".store-info .phone span").on("click", function() {
    $(this)
      .parent()
      .addClass("show");
    // GA event tracking
    ga("send", "event", "Click", "Show Phone", "Show Store Phone");
  });
}

/*
 * Video handling
 */
var videoDefer = jQuery.Deferred();
var players = {};

// called automatically by the api
function onYouTubeIframeAPIReady() {
  videoDefer.resolve();
}

function createVideo(playerId, videoId, options) {
  // merge passed options on top of defaults
  options = jQuery.extend(
    {
      controls: 0,
      showinfo: 0,
      rel: 0,
      autoplay: 0,
      loop: 0,
      playlist: videoId,
      disablekb: 1,
      fs: 0,
      modestbranding: 1
    },
    options
  );

  videoDefer.done(function() {
    // make the player instance
    players[playerId] = new YT.Player(playerId, {
      videoId: videoId,
      playerVars: options,
      events: {
        onReady: function(event) {
          // if autoplay, mute on ready
          if (options.autoplay === 1) {
            event.target.mute();
          }
        },
        onStateChange: function(event) {
          // Check if we have an overlay. If we don't, skip out now.
          var $overlay = $('[data-player-id="' + playerId + '"]');
          if (!$overlay.length) {
            return;
          }

          // Show/hide overlay based on playing state
          var playing =
            [YT.PlayerState.PLAYING, YT.PlayerState.BUFFERING].indexOf(
              event.data
            ) !== -1;
          $overlay[playing ? "addClass" : "removeClass"]("playing")
            .find(".title, .fa")
            [playing ? "hide" : "show"]();
        }
      }
    });

    resizeVideo(playerId);
  });
}

function resizeVideo(playerId) {
  // work out & save ratio onto the element
  var $player = $("#" + playerId);
  var ratio = $player.height() / $player.width();
  $player.data("ratio", ratio);

  // run an initial resize
  var width = $player.parent().width();
  const sectionInner = $player.parent().find(".section.inner");
  $player.parent().height(sectionInner.innerHeight());
  players[playerId].setSize(width, width * ratio);
}

$(function() {
  $(window).resize(function() {
    $(".youtube-player").each(function() {
      resizeVideo($(this).attr("id"));
    });
  });
});

/*
 * Map handling
 */
var mapDefer = jQuery.Deferred();
var markers = {};
var anonId = 0;
var infoWindow = null;

// Create a map, with initial position and zoom.
function createMap(lat, lng, zoom) {
  // Build the gmap & send it out over the defer
  mapDefer.resolve(
    new google.maps.Map(document.getElementById("map-container"), {
      center: { lat: lat, lng: lng },
      zoom: zoom,
      maxZoom: 18,
      // draggable: false,
      // scrollwheel: false,
      // mapTypeControl: false,
      // streetViewControl: false,
      // zoomControl: false,
      // disableDoubleClickZoom: true,
      // gestureHandling: 'none',
      styles: mapStyles
    })
  );
}

function openStoreLink(url, marker) {
  // Just go straight there, taking bets on how long before they want the ajax back.
  window.location.href = url;
  return;

  jQuery.get(url, function(response) {
    $(".store-info.ajax")
      .html(response)
      .show()
      .css("left", "");
    hideStorePhone();
    calculateStoreDistance();
    centreMapOnMarker(marker);
  });
  setTimeout(function() {
    $(".scroll-pane").jScrollPane();
  }, 1000);
}

// Calculate the distance to the current store
function calculateStoreDistance() {
  // If there's a distance to calculate, try grabbing it
  var $distance = $(".locations .store-info .distance");
  if ($distance.length && "geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(function(pos) {
      var distance = haversine(
        $distance.data("lat"),
        $distance.data("lng"),
        pos.coords.latitude,
        pos.coords.longitude
      );

      var unit = "km";
      if (distance < 1) {
        distance = Math.round(distance * 1000);
        unit = "m";
      } else if (distance < 10) {
        distance = Math.round(distance * 10) / 10;
      } else {
        distance = Math.round(distance);
      }

      $distance.text(distance + unit).show();
    });
  }
}

// Place a marker on the map, will wait for the map before placing
function placeMarker(params) {
  var lat = params.lat ? params.lat : 0;
  var lng = params.lng ? params.lng : 0;
  var id = params.id ? params.id : "anon" + anonId++;

  // Wait for the map
  mapDefer.done(function(map) {
    // Build a marker object
    var markerParams = {
      position: { lat: lat, lng: lng }
    };
    if (params.url) {
      markerParams.url = params.url;
    }
    // Create an info window for the marker
    markerParams.node = $(".info-windows [data-location-id=" + id + "]")[0];
    var marker = new google.maps.Marker(markerParams);
    setMarkerActive(marker, params.active);
    marker.addListener("mouseover", function() {
      setMarkerActive(marker, true);
    });
    marker.addListener("mouseout", function() {
      setMarkerActive(marker, params.active);
    });
    marker.setMap(map);

    // Save it into the marker array
    markers[id] = marker;

    // On click, virtualise a click on the corresponding store info button
    marker.addListener("click", function() {
      if (this.url) {
        return openStoreLink(this.url, this);
      }
      var store = $(".list-item[data-location-id=" + id + "] .store-info-link");
      if (store.length) {
        openStoreLink(store.attr("href"), this);
      }
    });
  });
}

// Center & zoom a map onto a single marker
function centreMapOnMarker(marker) {
  mapDefer.done(function(map) {
    map.setZoom(18);
    map.setCenter(marker.getPosition());
  });
}

// Centre & zoom map to contain all markers
function centreMapOnMarkers() {
  // Wait for map
  mapDefer.done(function(map) {
    var bounds = new google.maps.LatLngBounds();
    for (var key in markers) {
      bounds.extend(markers[key].getPosition());
    }
    map.fitBounds(bounds);
  });
}

// Set the active marker
function setMarkerActive(marker, active) {
  var color = active ? "cream" : "green";
  marker.setIcon({
    url: "/assets/images/pin-" + color + ".png",
    anchor: { x: 31, y: 77 }
  });

  // Make sure there's an info window
  if (!infoWindow) {
    infoWindow = new google.maps.InfoWindow();
  }

  // If we're closing, don't set any content
  if (!active) {
    // infoWindow.close();
    return;
  }

  // Opening - set content then open
  mapDefer.done(function(map) {
    // Remove old link handling
    $(infoWindow.getContent())
      .find(".store-info-link")
      .off("click");

    // Set the content up and show the window
    infoWindow.setContent(marker.node);
    infoWindow.open(map, marker);

    // thing
    var node = $(marker.node);
    var locationId = node.data("location-id");
    var listItem = $(".locations .list").find(
      "[data-location-id=" + locationId + "]"
    );
    if (listItem.length) {
      node.find(".distance").html(
        listItem
          .find(".distance")
          .text()
          .replace(" away", "&nbsp;&nbsp;")
      );
    }

    // Hook up a new click event
    $(infoWindow.getContent())
      .find(".store-info-link")
      .click(function() {
        openStoreLink($(this).attr("href"), marker);
        return false;
      });
  });
}

// Calculate a distance between two points using the haversine formula
function haversine(lat1, lng1, lat2, lng2, unit) {
  if (unit === undefined) {
    unit = "km";
  }

  function toRad(deg) {
    return (deg * Math.PI) / 180;
  }

  var radius = unit === "km" ? 6371 : 3959;
  return (
    radius *
    Math.acos(
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.cos(toRad(lng2) - toRad(lng1)) +
        Math.sin(toRad(lat1)) * Math.sin(toRad(lat2))
    )
  );
}

$(function() {
  // move the ajax store info container off to the left
  var $storeInfo = $(".store-info.ajax");
  $storeInfo.css("left", -$storeInfo.width() + 200);

  // Set the marker corresponding to the hovered search result to be active
  $(".locations .list-item")
    .hover(function(event) {
      var marker = markers[$(this).data("location-id")];
      setMarkerActive(marker, event.type === "mouseenter");
    })

    // Request store info over ajax on search result click
    .find(".store-info-link")
    .click(function() {
      var $this = $(this);
      openStoreLink(
        $this.attr("href"),
        markers[$this.closest(".list-item").data("location-id")]
      );
      return false;
    });

  // Handle form submissions
  $(".location-form").submit(function() {
    // Filter out unused inputs
    $(this)
      .find("[name]")
      .each(function() {
        if ($(this).val() === "") {
          $(this).removeAttr("name");
        }
      });
  });

  // On selection of a state from the store search drop down, auto-submit the search
  $(".location-form [name=state]").change(function() {
    var form = $(this).closest("form");
    // Clear the search input to prevent muddying the search
    form.find("[name=search]").val("");

    form.submit();
  });

  // On click of the 'use current location', try to get a geolocation and submit that as a search
  $(".location-form .current-location").click(function() {
    if (!("geolocation" in navigator)) {
      return;
    }

    var form = $(this).closest("form");

    navigator.geolocation.getCurrentPosition(function(pos) {
      form.find("[name=search]").val("");
      form.find("[name=lat]").val(pos.coords.latitude);
      form.find("[name=lng]").val(pos.coords.longitude);
      form.submit();
    });
  });

  // handle the close store button
  $storeInfo.on("click", ".close-store", function() {
    centreMapOnMarkers();
    $storeInfo.css("left", -$storeInfo.width() + 200);
    // var the css animation play
    setTimeout(function() {
      $storeInfo.hide();
    }, 200);
    return false;
  });

  calculateStoreDistance();
});

/*
 * Map style array
 */
var mapStyles = [
  {
    featureType: "administrative",
    elementType: "all",
    stylers: [{ visibility: "on" }, { lightness: 33 }]
  },
  {
    featureType: "administrative",
    elementType: "labels",
    stylers: [{ saturation: "-100" }]
  },
  {
    featureType: "administrative",
    elementType: "labels.text",
    stylers: [{ gamma: "0.75" }]
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "labels.text.fill",
    stylers: [{ lightness: "-37" }]
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#f9f9f9" }]
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry",
    stylers: [
      { saturation: "-100" },
      { lightness: "40" },
      { visibility: "off" }
    ]
  },
  {
    featureType: "landscape.natural",
    elementType: "labels.text.fill",
    stylers: [{ saturation: "-100" }, { lightness: "-37" }]
  },
  {
    featureType: "landscape.natural",
    elementType: "labels.text.stroke",
    stylers: [{ saturation: "-100" }, { lightness: "100" }, { weight: "2" }]
  },
  {
    featureType: "landscape.natural",
    elementType: "labels.icon",
    stylers: [{ saturation: "-100" }]
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ saturation: "-100" }, { lightness: "80" }]
  },
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ saturation: "-100" }, { lightness: "0" }]
  },
  {
    featureType: "poi.attraction",
    elementType: "geometry",
    stylers: [{ lightness: "-4" }, { saturation: "-100" }]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      { color: "#c5dac6" },
      { visibility: "on" },
      { saturation: "-95" },
      { lightness: "62" }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels",
    stylers: [{ visibility: "on" }, { lightness: 20 }]
  },
  { featureType: "road", elementType: "all", stylers: [{ lightness: 20 }] },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [{ saturation: "-100" }, { gamma: "1.00" }]
  },
  {
    featureType: "road",
    elementType: "labels.text",
    stylers: [{ gamma: "0.50" }]
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ saturation: "-100" }, { gamma: "0.50" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#c5c6c6" }, { saturation: "-100" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ lightness: "-13" }]
  },
  {
    featureType: "road.highway",
    elementType: "labels.icon",
    stylers: [{ lightness: "0" }, { gamma: "1.09" }]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#e4d7c6" }, { saturation: "-100" }, { lightness: "47" }]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{ lightness: "-12" }]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.icon",
    stylers: [{ saturation: "-100" }]
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ color: "#fbfaf7" }, { lightness: "77" }]
  },
  {
    featureType: "road.local",
    elementType: "geometry.fill",
    stylers: [{ lightness: "-5" }, { saturation: "-100" }]
  },
  {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [{ saturation: "-100" }, { lightness: "-15" }]
  },
  {
    featureType: "transit.station.airport",
    elementType: "geometry",
    stylers: [{ lightness: "47" }, { saturation: "-100" }]
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [{ visibility: "on" }, { color: "#acbcc9" }]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ saturation: "53" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ lightness: "-42" }, { saturation: "17" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ lightness: "61" }]
  }
];

/*Geolocation modal*/

$(document).ready(function() {
  $.getJSON("https://api.ipify.org?format=json", function(data) {
    var ip = data["ip"]; // - live

    //var ip = '101.0.116.105'; // - AU
    //var ip = '121.72.165.118'; //- NZ
    //var ip = '92.251.255.11'; //- IE
    //var ip = '72.229.28.185'; //- USA

    $.getJSON("https://ipapi.co/" + ip + "/json/", function(data) {
      var countryCode = data["country"];
      var countryName = $("." + countryCode + "CountryName").val();

      var hostExtension = window.location.host.split(".").pop();

      modalTitle = $(".modalTitle").text();
      thisSiteIsFor = $(".thisSiteIsFor").text();
      wouldYouLikeToVisit = $(".wouldYouLikeToVisit").text();
      takeMeToText = $(".takeMeToButton-text").text();
      continueToText = $(".continueToButton").text();

      country = countryName;
      takeMeToText = takeMeToText + " " + countryCode;
      modalTitle = modalTitle + " " + country;
      wouldYouLikeToVisit = wouldYouLikeToVisit + " " + country;

      flagImage = $("." + countryCode + "FlagImage").val();
      backgroundImage = $("." + countryCode + "BackgroundImage").val();
      originCountryCode = countryName;
      takeMeToLink = $("." + countryCode + "SiteLInk").val();
      continueToLink = window.location.href;

      siteCountry = $(".siteCountryName").val();
      siteCountryCode = $(".siteCountryCode").val();

      thisSiteIsFor = thisSiteIsFor + " " + siteCountry;
      continueToText = continueToText + " " + siteCountryCode;

      zambreroCountry = false;
      $(".countryCodes").each(function() {
        if (this.value == countryCode) {
          zambreroCountry = true;
        }
      });

      if (
        !Cookies.get("website") &&
        zambreroCountry &&
        countryCode !== siteCountryCode
      ) {
        if (getUrlParameter("website")) {
          Cookies.set("website", getUrlParameter("website"));
          var clean_uri =
            location.protocol + "//" + location.host + location.pathname;
          window.history.replaceState({}, document.title, clean_uri);
        } else {
          $(".thisSiteIsFor").html(thisSiteIsFor + ".");
          $(".wouldYouLikeToVisit").html(wouldYouLikeToVisit + " instead?");
          $(".takeMeToButton-text").html(takeMeToText);
          $(".takeMeToButton").attr("href", takeMeToLink);
          $(".continueToButton").html(continueToText);
          $(".continueToButton").attr("href", continueToLink);
          $(".modalTitle").html(modalTitle + "!");
          $(".flagImage").attr("src", flagImage);
          $("#geolocationModal").css(
            "background-image",
            "url(" + backgroundImage + ")"
          );
          $("#geolocationModal").fadeIn();
          $('<div class="overlay"></div>').appendTo("body");
        }
      } else {
        getUrl = window.location;
        baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
        if (Cookies.get("website") && Cookies.get("website") !== baseUrl) {
          if (
            getUrlParameter("website") &&
            getUrlParameter("website") !== Cookies.get("website")
          ) {
            Cookies.set("website", getUrlParameter("website"));
            /*window.location.replace(Cookies.get('website'));*/
          }
        }
      }
    });
  });

  $(".continueToButton, .close").click(function(e) {
    e.preventDefault();
    if ($(this).hasClass("continueToButton")) {
      Cookies.set("website", $(this).attr("href"));
    }
    $("#geolocationModal").fadeOut();
    $(".overlay").remove();
  });

  $(".siteLink").click(function(e) {
    e.preventDefault();
    Cookies.set("website", $(this).attr("href"));
    window.location.replace(
      $(this).attr("href") + "?website=" + $(this).attr("href")
    );
  });

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  };
});

document.addEventListener("readystatechange", function() {
  if (document.readyState === "complete") {
    var frontCurvedSelector = ".timeline-section.-front-cover .curved";
    var curvedChapterLabelSelector =
      ".timeline-section.-chapter .chapter-label.curved";
    var curvedYearLabelSelector =
      ".timeline-section.-chapter .year-label.curved";
    var rotateStyle =
      "-webkit-transform: rotate(-45deg); -ms-transform: rotate(-45deg); transform: rotate(-45deg);";

    var frontCurved = document.querySelector(frontCurvedSelector);
    var curvedChapterLabels = document.querySelectorAll(
      curvedChapterLabelSelector
    );
    var curvedYearLabels = document.querySelectorAll(curvedYearLabelSelector);

    if (frontCurved) {
      new CircleType(frontCurved).radius(120);
      frontCurved.parentElement.style = rotateStyle;
    }

    for (var i = 0; i < curvedChapterLabels.length; i++) {
      new CircleType(curvedChapterLabels[i]).radius(120);
      curvedChapterLabels[i].parentElement.style = rotateStyle;
    }

    for (var i = 0; i < curvedYearLabels.length; i++) {
      new CircleType(curvedYearLabels[i]).radius(45);
    }
    var sections = document.querySelectorAll(
      ".timeline-section, .horizontal-timeline"
    );
    for (var i = 0; i < sections.length; i++) {
      sections[i].style.opacity = "1";
    }
  }
});
